// local imports
import { primaryColor } from '~/colors'

const toggle = {
    cursor: 'pointer',
    marginBottom: 12,
    display: 'flex',
    alignItems: 'center'
}

const title = {
    marginLeft: 2,
    marginBottom: 0
}

export default {
    toggle,
    titleActive: {
        ...title,
        color: primaryColor
    },
    titleInactive: {
        ...title
    },
    content: {
        marginLeft: 20
    }
}



// WEBPACK FOOTER //
// ./src/components/Accordion/styles.js